// extracted by mini-css-extract-plugin
export default {"HWHardwareView":"HWHardwareView_HWHardwareView__gM8I6"};